import React, { useContext } from 'react';
import LoadingContext from '../../context/loadingContext/LoadingContext';
import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import styles from './LoadModal.module.scss';

const LoadingIcon = <LoadingOutlined style={{ fontSize: 48 }} spin />;

const LoadModal = () => {
  const { isLoading } = useContext(LoadingContext);

  if (!isLoading) return null;

  return (
    <div className={`load-modal ${styles.spinWrapper}`}>
      <div className={styles.loadingIconContainer}>
        <Spin
          size="large"
          indicator={LoadingIcon}
          spinning={true}
          className={styles.spinner}
        />
      </div>
    </div>
  );
};
export default LoadModal;
